import React from 'react'
import Tooltip from 'components/generic/tooltip'
import { uniqBy } from 'lodash'

const getMaterialsCell = (cellData, key = 'materials') => {
  const materials = cellData.row[key]

  const uniqueMaterialNames = uniqBy(materials, 'materialType.commonName').map(
    material => material.materialType.commonName,
  )

  const columnString = uniqueMaterialNames.length > 1 ? 'Mixed' : uniqueMaterialNames[0]
  return (
    <Tooltip content={uniqueMaterialNames.join(', ')}>
      <>{columnString}</>
    </Tooltip>
  )
}

export default getMaterialsCell
